import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  userDetails: any;
  imagesProfile:any;
  logname:any
  userProfile:any;
  degrees:any
  userroleName:any;
  showdegree:boolean=false
  public menuItems: Menu[] | any;
  public url: any;
  public fileurl: any;
  myGroup: FormGroup;
  constructor(private router: Router, public navServices: NavService) {
    this.userDetails = localStorage.getItem("currentUser");

   

    this.myGroup = new FormGroup({
      firstName: new FormControl()
    });
  
    this.navServices.initializeItems(this.userDetails);

    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url)
              this.setNavActive(items);
            if (!items.children) return false;
            items.children.filter(subItems => {
              if (subItems.path === event.url)
                this.setNavActive(subItems);
              if (!subItems.children) return false;
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url)
                  this.setNavActive(subSubItems);
              });
              return;
            });
            return;
          });
        }
      });
    });

    // this.userDetails = localStorage.getItem('currentUser');
    this.imagesProfile=JSON.parse(this.userDetails)[0].image_url;

    if(JSON.parse(this.userDetails)[0].degree=="UG"){
      this.logname="UGAM"
    }else{
      this.logname="PGAM"
    }

    if(JSON.parse(this.userDetails)[0].loginType=='staff'){
      this.userProfile=JSON.parse(this.userDetails)[0].name;
      this.userroleName=JSON.parse(this.userDetails)[0].loginType;
      this.showdegree=false
    }
    if(JSON.parse(this.userDetails)[0].loginType=='regular'){
      this.userProfile=JSON.parse(this.userDetails)[0].username;
      this.userroleName=JSON.parse(this.userDetails)[0].roleName;
      this.showdegree=false
    }
    if(JSON.parse(this.userDetails)[0].loginType=='student'){
      this.userProfile=JSON.parse(this.userDetails)[0].name;
      this.userroleName=JSON.parse(this.userDetails)[0].loginType;
      this.degrees=JSON.parse(this.userDetails)[0].degree;
      this.showdegree=true
    }
  }

  // Active Nave state
  setNavActive(item:any) {
    this.menuItems.filter((menuItem:any) => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter((submenuItems:any) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  // Click Toggle menu
  toggletNavActive(item:any) {
    if (!item.active) {
      this.menuItems.forEach((a:any) => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach((b:any) => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
        return
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

  

}
